import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class DeleteProductSuggestApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productSuggest/deleteProductSuggest/',
      requesterInfo,
    })
  }

  public async deleteProductSuggest(id: number): Promise<any> {
    this.props.url = `${this.props.url}${id}`
    return await this.deleteAsync<any>()
  }
}
